app.controller('ReviewsForProductCtrl', ['$scope', '$rootScope', 'reviewsForSingleProduct', function($scope, $rootScope, reviewsForSingleProduct) {

  $scope.reviewsForSingleProduct = reviewsForSingleProduct;
  $scope.fyOptions = $rootScope.financialYears; // set by 'parent' segment resolves

}]);